(function () {
    'use strict';

    angular
        .module('app')
        .factory('WorkflowRunService', WorkflowRunService);

    WorkflowRunService.$inject = ['$http', '$q', '$rootScope', '$interval', '$location', 'UrlService', 'ChilliTenancyService', 'ChilliAuthService', 'DialogService'];

    function WorkflowRunService($http, $q, $rootScope, $interval, $location, UrlService, ChilliTenancyService, ChilliAuthService, DialogService) {
        var workflowApiUri;
        var signalRUri;
        var signalRConnection;
        var workflowHub;
        var activated;

        var service = {
            promptWorkflowStart: promptWorkflowStart,
            createInstance: createInstance,
            start: start,
            cancel: cancel,
            respondToStep: respondToStep,
            respondToStepWithFile: respondToStepWithFile,
            onEvent: onEvent
        };

        activate();

        return service;

        function activate() {
            registerSignalR();

            activated = $q.when(signalRConnection.start())
                .catch(function error() {
                    return $q.reject('Could not connect to workflow service');
                });
        }

        /**
         * Prompt the user with a selection for a workflow definition. Once the user selects
         * a workflow definition, that workflow is run.
         *
         * @param {number} entityId - Optional, an entity id to run the workflow for.
         */
        function promptWorkflowStart(entityId) {
            DialogService.show({
                locals: {},
                controller: 'WorkflowDefinitionSelectorDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/Workflow/workflow-definition-selector-dialog.tmpl.html',
            }).then(selectWorkflowOk);

            function selectWorkflowOk(data) {
                createInstance(data.Id, entityId).then(function (workflowInstanceId) {
                    $location.path('/runworkflow/' + workflowInstanceId);
                });
            }
        }

        /**
         * Returns promise for workflow instance id if successful.
         *
         * @param {number|string} definitionId - The workflow definition id.
         * @param {number|string} entityId - Optional, an entity id to run the workflow for.
         * @returns {Promise} A promise that resolves once the workflow instance has been created.
         *                    The promise resolves the id for the created workflow instance.
         *                    Rejects if there was an error creating the workflow instance.
         */
        function createInstance(definitionId, entityId) {
            var url = workflowApiUri + 'create/' + definitionId;
            if (!_.isNil(entityId)) {
                url += '/' + entityId;
            }

            return activated.then(function () {
                return $http.post(url)
                    .then(createInstanceOk, createInstanceError);
            });

            function createInstanceOk(response) {
                return response.data;
            }

            function createInstanceError(response) {
                return $q.reject(response);
            }
        }

        /**
         * Start execution of the specified workflow instance.
         */
        function start(instanceId) {
            return activated.then(function () {
                return $http.post(workflowApiUri + instanceId + '/start')
                    .then(null, startError);
            });

            function startError(response) {
                return $q.reject(response);
            }
        }

        /**
         * Cancel execution of the specified workflow instance.
         */
        function cancel(instanceId) {
            return activated.then(function () {
                return $http.post(workflowApiUri + instanceId + '/cancel')
                    .then(null, cancelError);
            });

            function cancelError(response) {
                return $q.reject(response);
            }
        }

        /**
         * Response to a workflow step, e.g. provide an answer to a question.
         */
        function respondToStep(instanceId, stepId, response) {
            return activated.then(function () {
                return $http.post(workflowApiUri + instanceId + '/' + stepId + '/response', {
                    Response: response
                });
            });
        }

        function respondToStepWithFile(instanceId, stepId, file, fileName) {
            return activated.then(function () {
                var formData = new FormData();
                formData.append("files", file);

                return $http.post(
                    workflowApiUri + instanceId + '/' + stepId + '/addfile',
                    formData,
                    {
                        headers: { 'Content-Type': undefined },
                        transformRequest: function (data) { return data; }
                    });
            });
        }


        function onEvent(scope, eventName, callback) {
            var cancelHandler = $rootScope.$on(eventName, callback);
            scope.$on('destroy', cancelHandler);
        }

        function registerSignalR() {
            workflowApiUri = UrlService.getWebAPIUrl() + '/workflow/';
            signalRUri = UrlService.getSignalRUrl();
            var reconnectPromise = null;
            signalRConnection = $.hubConnection(signalRUri);
            setAccessToken();

            signalRConnection.stateChanged(function (change) {
                // On connect, cancel reconnect interval and join tenancy group
                if (change.newState === $.signalR.connectionState.connected) {
                    if (reconnectPromise !== null) {
                        $interval.cancel(reconnectPromise);
                        reconnectPromise = null;
                    }

                    joinTenancyGroup();
                }

                // On disconnect, register reconnect interval
                if (change.newState === $.signalR.connectionState.disconnected) {
                    if (reconnectPromise === null) {
                        reconnectPromise = $interval(function () {
                            if (ChilliAuthService.isAuthenticated && signalRConnection.state === $.signalR.connectionState.disconnected) {
                                signalRConnection.start();
                            }
                        }, 5000);
                    }
                }
            });
            
            $rootScope.$on('chilliAuth:logout', function () {
                signalRConnection.stop();
            });

            workflowHub = signalRConnection.createHubProxy('workflowHub');

            registerEvent('workflowStepStarted');
            registerEvent('workflowStepUpdated');
            registerEvent('workflowStatusChange');
        }

        function setAccessToken() {
            signalRConnection.qs = { 'access_token': ChilliAuthService.idToken };
        }

        function joinTenancyGroup() {
            workflowHub.invoke('joinTenancyGroup', ChilliTenancyService.selectedTenancyId);
        }

        /**
         * Register a SignalR event to be emitted on the Angular rootscope.
         * The event in Angular will be prefixed with 'workflow:'.
         */
        function registerEvent(eventName) {
            workflowHub.on(eventName, function () {
                // Convert arguments into a true array
                var args = [];
                _.forEach(arguments, function (arg) { args.push(arg); });

                args.unshift('workflow:' + eventName);
                $rootScope.$emit.apply($rootScope, args);
            });
        }
    }
})();